import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import {doc, getDoc} from 'firebase/firestore';
import {db} from '../utils/firebase';
import {useLang} from '../context/LanguageContext';
import {DEFAULT_PREMIUM_TICKETS_ENABLED} from '../utils/premiumTickets';

const PremiumTicketsCard = () => {
    const {t} = useLang();
    const navigate = useNavigate();
    const [enabled, setEnabled] = useState(null);

    useEffect(() => {
        const loadSettings = async () => {
            try {
                const snap = await getDoc(doc(db, 'appSettings', 'premiumTickets'));
                setEnabled(snap.exists() && typeof snap.data().enabled === 'boolean'
                    ? snap.data().enabled
                    : DEFAULT_PREMIUM_TICKETS_ENABLED);
            } catch (err) {
                setEnabled(DEFAULT_PREMIUM_TICKETS_ENABLED);
            }
        };
        loadSettings();
    }, []);

    // sectiunea este controlata din /apanel (appSettings/premiumTickets -> enabled)
    if (!enabled) {
        return null;
    }

    return (
        <div className="flex flex-col w-full max-w-[400px] mx-auto my-4">
            <button
                onClick={() => navigate('/premium-tickets')}
                className="relative bg-[#f39c12] text-white text-center font-bold py-3 rounded shadow hover:bg-orange-600 transition"
            >
                <span className="absolute -top-2 right-4 bg-red-500 text-white text-[10px] font-bold px-2 py-0.5 rounded-full shadow animate-pulse">
                    NEW
                </span>
                {t('txt.premiumTicketsSectionTitle')}
            </button>
        </div>
    );
};

export default PremiumTicketsCard;
